import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { BaseComponent } from '../base/base.component';

@Component({
    selector: 'trg-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
})
export class RatingComponent extends BaseComponent implements OnInit {
    @Input() rating: number;
    @Input() max: number = 100;
    @Input() isMarginless: boolean = false;
    @Input('count') count: number;
    @Input('starSize') starSize: number = 2;

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }

    public ngOnInit() {
        this.classes = ['marginless'];

        if (this.max !== 100) {
            this.rating = Math.floor((Number(this.rating) * 100) / this.max);
        }
    }
}
